const LEASING_BUTTON_SELECTOR = ".leasing-atc-button";
const STANDARD_CHECKOUT_SELECTOR =
  'button[name="checkout"], input[name="checkout"], a[href="/checkout"]';
const LEASING_ATTRIBUTE_PREFIXES = ["lf_", "la_field_", "leasing_field_"];
let checkoutIntentInFlight = false;

function resetCheckoutIntent() {
  checkoutIntentInFlight = false;
}

function getElementTarget(target) {
  if (target instanceof Element) {
    return target;
  }

  return target?.parentElement || null;
}

function shouldClearLeasingAttribute(key) {
  if (!key || key === "leasing") {
    return false;
  }

  if (key === "leasing_provider_slug") {
    return true;
  }

  if (key.startsWith("leasing_")) {
    return true;
  }

  return LEASING_ATTRIBUTE_PREFIXES.some((prefix) => key.startsWith(prefix));
}

async function fetchCart() {
  const response = await fetch("/cart.js", {
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error("Unable to load cart");
  }

  return response.json();
}

async function updateCartAttributes(attributes) {
  const response = await fetch("/cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ attributes }),
  });

  if (!response.ok) {
    throw new Error("Unable to update cart attributes");
  }

  return response.json();
}

async function prepareCheckout({ isLeasing }) {
  const cart = await fetchCart();
  const attributes = {
    hostUrl: window.location.host,
    leasing: isLeasing,
  };

  if (!isLeasing) {
    const cartAttributes = cart.attributes || {};

    Object.keys(cartAttributes).forEach((key) => {
      if (shouldClearLeasingAttribute(key)) {
        attributes[key] = "";
      }
    });

    attributes.leasing_provider_slug = "";
  }

  await updateCartAttributes(attributes);
}

async function handleCheckoutIntent({ isLeasing }) {
  if (checkoutIntentInFlight) {
    return;
  }

  checkoutIntentInFlight = true;

  try {
    await prepareCheckout({ isLeasing });
    window.location.assign("/checkout");
  } catch (error) {
    resetCheckoutIntent();
    console.error("Unable to prepare checkout", error);
  }
}

function isLeasingButton(target) {
  const elementTarget = getElementTarget(target);
  return elementTarget?.closest(LEASING_BUTTON_SELECTOR);
}

function isStandardCheckoutTarget(target) {
  const elementTarget = getElementTarget(target);
  const checkoutTarget = elementTarget?.closest(STANDARD_CHECKOUT_SELECTOR);

  if (!checkoutTarget) {
    return false;
  }

  return !checkoutTarget.closest(LEASING_BUTTON_SELECTOR);
}

function getAssociatedForm(target) {
  const elementTarget = getElementTarget(target);
  const submitter = elementTarget?.closest(`${STANDARD_CHECKOUT_SELECTOR}, ${LEASING_BUTTON_SELECTOR}`);

  return submitter?.form || elementTarget?.closest("form") || null;
}

function isTermsAccepted(target) {
  const form = getAssociatedForm(target);
  if (!form) {
    return true;
  }

  const termsCheckbox = form.id
    ? document.querySelector(`.js-cart-terms-checkbox[form="${form.id}"]`) || form.querySelector(".js-cart-terms-checkbox")
    : form.querySelector(".js-cart-terms-checkbox");

  if (!termsCheckbox || termsCheckbox.checked) {
    return true;
  }

  alert(theme.strings.cartTermsConfirmation);
  return false;
}

function onCheckoutClick(event) {
  if (isLeasingButton(event.target)) {
    event.preventDefault();
    if (!isTermsAccepted(event.target)) {
      return;
    }
    handleCheckoutIntent({ isLeasing: true });
    return;
  }

  if (isStandardCheckoutTarget(event.target)) {
    event.preventDefault();
    if (!isTermsAccepted(event.target)) {
      return;
    }
    handleCheckoutIntent({ isLeasing: false });
  }
}

function onCheckoutSubmit(event) {
  const submitter = event.submitter;

  if (!submitter) {
    return;
  }

  if (isLeasingButton(submitter)) {
    event.preventDefault();
    if (!isTermsAccepted(submitter)) {
      return;
    }
    handleCheckoutIntent({ isLeasing: true });
    return;
  }

  if (isStandardCheckoutTarget(submitter)) {
    event.preventDefault();
    if (!isTermsAccepted(submitter)) {
      return;
    }
    handleCheckoutIntent({ isLeasing: false });
  }
}

document.addEventListener("click", onCheckoutClick, true);
document.addEventListener("submit", onCheckoutSubmit, true);
document.addEventListener("on:bfcache:load-restore", resetCheckoutIntent);
window.addEventListener("pageshow", resetCheckoutIntent);
